import { Button, Modal } from 'antd';
import { History } from '../../../common/components/History/History';
import { useGetMerchantHistoryQuery } from '../store/merchant.api';

interface MerchantHistoryProps {
  merchantId: string;
  isOpen: boolean;
  onClose: () => void;
}

export const MerchantHistory = ({
  isOpen,
  onClose,
  merchantId,
}: MerchantHistoryProps) => {
  const { data: historyData, isLoading } =
    useGetMerchantHistoryQuery(merchantId);

  return (
    <Modal
      open={isOpen}
      width={1024}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <History
        title="Merchant History"
        data={historyData?.data || []}
        isLoading={isLoading}
      />
    </Modal>
  );
};
